var map = {
	"./aba.png": "1172",
	"./acb.png": "7258",
	"./acleda.png": "046b",
	"./bidv.png": "11e8",
	"./channel-icons/Han_2.png": "5563",
	"./channel-icons/Han_3.png": "1ef2",
	"./channel-icons/Roulette icon.png": "dc4b",
	"./channel-icons/aporng icon 1.png": "d3a9",
	"./channel-icons/aporng icon 2.png": "c497",
	"./channel-icons/baccarat icon 1.png": "3c4d",
	"./channel-icons/baccarat icon 2.png": "5bc9",
	"./channel-icons/baccarat icon 3.png": "4d73",
	"./channel-icons/baccarat icon 4.png": "ada8",
	"./channel-icons/cockfight copy.png": "c08d",
	"./channel-icons/cockfight icon 1.png": "448e",
	"./channel-icons/cockfight icon 2.png": "98c4",
	"./channel-icons/cockfight icon 3.png": "d890",
	"./channel-icons/cockfight icon 4.png": "0cbf",
	"./channel-icons/cockfight icon 5.png": "e4c4",
	"./channel-icons/cockfight icon 6.png": "7d8c",
	"./channel-icons/dragon tiger icon 1.png": "d7ac",
	"./channel-icons/dragon tiger icon 2.png": "6b76",
	"./channel-icons/dragon tiger icon 3.png": "a018",
	"./channel-icons/fantan icon 1.png": "e5a5",
	"./channel-icons/kla-klok icon 1.png": "5b16",
	"./channel-icons/lotto icon 1.png": "f85b",
	"./channel-icons/taisiev icon 1.png": "4166",
	"./channel-icons/yuki icon 1.png": "8c20",
	"./cockfight icon.png": "deda",
	"./cycle-blue.png": "105f",
	"./cycle-red.png": "3d00",
	"./donggabank.png": "5193",
	"./flag-en.webp": "8444",
	"./flag-kh.png": "db0a",
	"./flag-th.jpg": "1e65",
	"./flag-vn.png": "b0e5",
	"./h_slot_machine.png": "12b4",
	"./header-kbac.png": "5f6c",
	"./homepage-logo.png": "59e0",
	"./klaklok/img/OnPlate.png": "6d94",
	"./klaklok/img/Under_Plate.png": "3694",
	"./live-casino-icon.png": "3f9c",
	"./mb.png": "ca13",
	"./new-icon.gif": "c8a2",
	"./round-blue.png": "813f",
	"./round-dollar.png": "5713",
	"./round-red.png": "671c",
	"./round-yellow.png": "a79e",
	"./sacombank.png": "60f9",
	"./sathapana.png": "d648",
	"./techcombank.png": "e662",
	"./truemoney.png": "0e73",
	"./vietcombank.png": "ee4c",
	"./vietinbank.png": "78f3",
	"./wing.png": "225a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";